<div
  class="flex items-center justify-between mb-x-sm"
  [style.width.rem]="width()"
  [class]="label() ? 'justify-between' : 'justify-end'">
  @if (label()) {
    <label
      class="text-sm"
      [class.text-neutral-300]="disabled()"
      [class.cursor-not-allowed]="disabled()"
      [class.text-neutral-900]="!disabled()"
      [class.font-medium]="!disabled()"
      [class.label-required]="requiredEn() || requiredAr() || requiredGroup()"
      [for]="id()">
      {{ label() }}
    </label>
  }

  <!-- Language Switch -->
  @if (!isSingleInput()) {
    <div class="flex items-center gap-sm lang-switch">
      <button
        type="button"
        class="lang-button"
        [class.active]="currentLang() === 'EN'"
        [class.has-error]="
          childControlEn && childControlEn.touched && childControlEn.errors
        "
        (click)="switchLanguage('EN')">
        EN
      </button>
      <button
        type="button"
        class="lang-button"
        [class.active]="currentLang() === 'AR'"
        [class.me-xl]="isHasToolTip()"
        [class.has-error]="
          childControlAr && childControlAr.touched && childControlAr.errors
        "
        (click)="switchLanguage('AR')">
        AR
      </button>
    </div>
  }
</div>

<div class="flex flex-col">
  <div>
    <!-- English Textarea -->
    <div class="relative flex items-center" [hidden]="currentLang() !== 'EN'">
      @if (startIcon()) {
        <div
          class="icon start-3"
          [class.opacity-30]="disabled()"
          [class.cursor-not-allowed]="disabled()">
          <img [src]="startIcon()" alt="start-icon" />
        </div>
      }
      <div class="w-full" [class.text-neutral-300]="disabled()">
        <lib-tiptap-rich-editor
          [placeholder]="placeholderEn()"
          [canResize]="true"
          [inputFormControlName]="
            isSingleInput() ? inputFormControlName() : 'en'
          "
          [isDualLangEnabled]="true"
          [maxLength]="maxlength()"
          [disabled]="disabled()" />
      </div>
    </div>

    <!-- Arabic Textarea -->
    <div class="relative flex items-center" [hidden]="currentLang() !== 'AR'">
      @if (startIcon()) {
        <div
          class="icon start-3"
          [class.opacity-30]="disabled()"
          [class.cursor-not-allowed]="disabled()">
          <img [src]="startIcon()" alt="start-icon" />
        </div>
      }

      <div
        class="w-full"
        [class.has-errors]="
          (isSingleInput() ? childControlEn : childControlAr) &&
          (isSingleInput() ? childControlEn : childControlAr).touched &&
          (isSingleInput() ? childControlEn : childControlAr).errors
        "
        [class.text-destructive-900]="
          (isSingleInput() ? childControlEn : childControlAr) &&
          (isSingleInput() ? childControlEn : childControlAr).touched &&
          (isSingleInput() ? childControlEn : childControlAr).errors
        "
        [class.text-neutral-300]="disabled()">
        <lib-tiptap-rich-editor
          [placeholder]="placeholderAr()"
          [canResize]="true"
          [inputFormControlName]="
            isSingleInput() ? inputFormControlName() : 'ar'
          "
          [isDualLangEnabled]="true"
          [maxLength]="maxlength()"
          [disabled]="disabled()" />
      </div>
    </div>
  </div>

  <!-- Validation Messages -->
  <div>
    @if (!isSingleInput()) {
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        [control]="'en'"
        [isDualLang]="true"
        [requiredMessage]="requiredMessageEn()" />

      <lib-validation-message
        [lang]="'current_lang' | transloco"
        [control]="'ar'"
        [isDualLang]="true"
        [requiredMessage]="requiredMessageAr()" />
    } @else {
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        [control]="inputFormControlName()"
        [isDualLang]="true"
        [requiredMessage]="requiredMessageEn()" />
    }
  </div>
</div>
